import React from 'react';

import { Icon } from '@gitbook/spine-icons';

import { Button } from '../Button';
import { allSyntaxes, DEFAULT_SYNTAX, DEFAULT_SYNTAX_INFO } from './syntax/shiki';

export const SyntaxSelector = React.forwardRef<
    HTMLButtonElement,
    { active: boolean; onSelect: () => void; currentSyntax?: string }
>(function SyntaxSelector(props, ref) {
    const { active, onSelect, currentSyntax = DEFAULT_SYNTAX, ...buttonProps } = props;
    const syntaxInfo = React.useMemo(
        () => allSyntaxes.find((s) => s.key === currentSyntax) || DEFAULT_SYNTAX_INFO,
        [currentSyntax]
    );
    return (
        <Button
            {...buttonProps}
            iconOnly={false}
            ref={ref}
            active={active}
            trailingIcon={Icon.ChevronDown}
            onPress={onSelect}
            label={syntaxInfo.title}
        />
    );
});
